import * as types from './types';

export default {
  // change loading state
  [types.SET_IS_SEARCHING](state, params) {
    state.search.isLaunch = params;
  },
  [types.SET_IS_LOADING](state, params) {
    state.search.isLoading = params;
  },
  [types.PUSH_ALERT](state, content) {
    const localContent = { ...content };
    if (!state.blockAlerts) {
      const id = state.alerts.length === 0 ? 0 : state.alerts[state.alerts.length - 1].id + 1;
      localContent.time = new Date().getTime();
      state.alerts.push({ id, ...localContent });
    }
  },
  [types.UPDATE_ALERT](state, value) {
    const index = state.alerts.findIndex(x => x.id === value.id);
    state.alerts.splice(index, 1, { ...value });
  },
  [types.REMOVE_ALERT](state, alertId) {
    const index = state.alerts.indexOf(alert => alert.id === alertId);
    state.alerts.splice(index, 1);
  },
  [types.RESET_ALERT](state, value) {
    state.alerts = value;
  },
  [types.SET_TIMELINE_FIXED](state, value) {
    state.timelineFixed = value;
  },
  [types.SET_IS_MINI_VARIANT](state, value) {
    state.isMiniVariant = value;
  },
};
